export default __webpack_public_path__ + "1440d8104536cd0f9b6c0bcf6d9302b1.png";